<template>
	<div class="atividadelistagem">
		<loader object="#df3e46" v-show="progress" color1="#0db9d3" color2="#fff01f" size="6" speed="2.4" bg="#C0C0C0"
			objectbg="#0d0c0d" opacity="50" name="circular"></loader>
		<div class="container-fluid">
			<ol class="breadcrumb-arrow">
				<li>
					<a href="/home"><i class="fa fa-home"></i></a>
					<a href="/atividade-listagem">Atividades</a>
				</li>
			</ol>
		</div>

		<div class="container-fluid mt-2">
			<div class="container-fluid mt-2">
				<div class="card">
					<div class="card-body">
						<div class="row">
							<div class="col-6 text-left">
								<a class="btn btn-light" data-toggle="collapse" href="#collapseFiltro" role="button" tabindex="1"
									aria-expanded="true" aria-controls="collapseFiltro">
									<i class="text-muted fas fa-stream mr-2"></i>
									Filtro
								</a>
							</div>
							<div class="col-6 text-right">

								<div class="col-lg-12 col-sm-12 text-right">
									<el-tooltip content="Incluir atividade" placement="top">
										<span>
											<button type="button" tabindex="2" class="btn btn-info"
												@click="incluirAtividade()">
												<i class="fa fa-plus mr-2"></i>
												<span>Incluir</span>
											</button>
										</span>
									</el-tooltip>
								</div>

							</div>
						</div>
						<div class="collapse" id="collapseFiltro">
							<div class="font-13 pt-2">

								<div class="row">
									<div class="col-9">

										<div class="col-10">
											<div class="ml-1 font-weight-bold">Filtrar por Projeto</div>
											<v-select class="campoMultiploProjeto mb-2" :tabindex="3"
												placeholder="Selecione um Projeto" label="codigoNome" multiple
												:reduce="(u) => u.idprojeto" v-model="filtro.projetos"
												:options="listaProjetos">
												<template v-slot:option="option">
													{{ option.codigoNome }} ({{option.situacaoDescricao}})
												</template>
												<span slot="no-options" @click="$refs.select.open = false">
													Nenhum registro encontrado
												</span>
											</v-select>
										</div>
									</div>

								</div>

								<div class="mt-2 row border rounded-top font-weight-bold">
									<div class="text-center col-6 filtro-contexto-inativo">
										Projeto
									</div>
									<div class="text-center col-6 filtro-contexto-ativo">
										Atividade
									</div>
								</div>
								<div class="row">

									<!-- div Projeto -->
									<div class="col-6 py-1 filtro-contexto-inativo-corpo">
										<div class="form-check">
											<div class="row">
												<div class="col-4">
													<input class="form-check-input" type="checkbox" value="true"
														v-model="filtro.projetosituacaoNI" id="sitProjetoCheck1" tabindex="4">
													<label class="form-check-label" for="sitProjetoCheck1">
														Não Iniciado
													</label>
												</div>
												<div class="col-4">
													<input class="form-check-input" type="checkbox" value="true"
														v-model="filtro.projetosituacaoEA" id="sitProjetoCheck2" tabindex="5">
													<label class="form-check-label" for="sitProjetoCheck2">
														Em Andamento
													</label>
												</div>
												<div class="col-4">
													<input class="form-check-input" type="checkbox" value="true"
														v-model="filtro.projetosituacaoVA" id="sitProjetoCheck8" tabindex="6">
													<label class="form-check-label" for="sitProjetoCheck8">
														Aguardando Validação
													</label>
												</div>
											</div>
											<div class="row">
												<div class="col-4">
													<input class="form-check-input" type="checkbox" value="true"
														v-model="filtro.projetosituacaoCA" id="sitProjetoCheck7" tabindex="7">
													<label class="form-check-label" for="sitProjetoCheck7">
														Cancelado
													</label>
												</div>
												<div class="col-4">
													<input class="form-check-input" type="checkbox" value="true"
														v-model="filtro.projetosituacaoCO" id="sitProjetoCheck3" tabindex="8">
													<label class="form-check-label" for="sitProjetoCheck3">
														Concluído
													</label>
												</div>
												<div class="col-4">
													<input class="form-check-input" type="checkbox" value="true"
														v-model="filtro.projetosituacaoRE" id="sitProjetoCheck5" tabindex="9">
													<label class="form-check-label" for="sitProjetoCheck5">
														Rejeitado
													</label>
												</div>
											</div>
											<div class="row">
												<div class="col-4">
													<input class="form-check-input" type="checkbox" value="true"
														v-model="filtro.projetosituacaoAT" id="sitProjetoCheck4" tabindex="10">
													<label class="form-check-label" for="sitProjetoCheck4">
														Atrasado
													</label>
												</div>
												<div class="col-4">
													<input class="form-check-input" type="checkbox" value="true"
														v-model="filtro.projetoReagendado" id="sitProjetoCheck9" tabindex="11">
													<label class="form-check-label" for="sitProjetoCheck9">
														Reagendado
													</label>
												</div>
											</div>
										</div>
										<div class="mt-2 row font-weight-bold">
											<div class="col">
												<div class="ml-2">Data Inicial</div>
												<flat-picker tabindex="12" id="projetoDataInicio" autocomplete="off"
													v-mask="'##/##/####'"
													class="font-13 form-control datepicker" placeholder="Data Inicial"
													v-model="filtro.projetoDataInicio" :config="configData"
													@blur.native="validarCampoData('projetoDataInicio', $event)"
													@on-ready="habilitarDigitacaoData" />
											</div>
											<div class="col">
												<div class="ml-2">Data Final</div>
												<flat-picker tabindex="13" id="projetoDataFim" autocomplete="off"
													v-mask="'##/##/####'"
													class="font-13 form-control datepicker" placeholder="Data Final"
													v-model="filtro.projetoDataFim" :config="configData"
													@blur.native="validarCampoData('projetoDataFim', $event)"
													@on-ready="habilitarDigitacaoData" />
											</div>
											<div class="col">
												<div class="ml-2">Data de Conclusão</div>
												<flat-picker tabindex="14" id="projetoDataConclusao" autocomplete="off"
													v-mask="'##/##/####'"
													class="font-13 form-control datepicker"
													placeholder="Data de Conclusão"
													v-model="filtro.projetoDataConclusao" :config="configData"
													@blur.native="validarCampoData('projetoDataConclusao', $event)"
													@on-ready="habilitarDigitacaoData" />
											</div>
										</div>
										<div class="mt-2 row">
											<div class="col">
												<div class="ml-2 font-weight-bold">Projeto criado por</div>
												<v-select class="mb-2" placeholder="Selecione Usuário" label="nome" :tabindex="15"
													multiple :reduce="(u) => u.idusuario"
													v-model="filtro.projetocriador" :options="listaUsuarios">
													<span slot="no-options" @click="$refs.select.open = false">
														Nenhum registro encontrado
													</span>
												</v-select>
											</div>
											<div class="col">
												<div class="ml-2 font-weight-bold">Responsável</div>
												<v-select class="mb-2" placeholder="Selecione Responsável" label="nome" :tabindex="16"
													multiple :reduce="(u) => u.idusuario"
													v-model="filtro.projetoresponsavel" :options="listaUsuarios">
													<span slot="no-options" @click="$refs.select.open = false">
														Nenhum registro encontrado
													</span>
												</v-select>
											</div>
										</div>
										<div class="mt-2 row">
											<div class="col">
												<div class="ml-2 font-weight-bold">Classificação</div>
												<v-select class="mb-2" placeholder="Selecione a Classificação" :tabindex="17"
													label="descricao" multiple :reduce="(c) => c.codigo"
													v-model="filtro.classificacao" :options="listaClassificacao">
													<span slot="no-options" @click="$refs.select.open = false">
														Nenhum registro encontrado
													</span>
												</v-select>
											</div>
											<div class="col">
												<div class="ml-2 font-weight-bold">Relevância</div>
												<v-select class="mb-2" placeholder="Selecione a Relevância" :tabindex="18"
													label="descricao" multiple :reduce="(c) => c.codigo"
													v-model="filtro.relevancia" :options="listaRelevancia">
													<span slot="no-options" @click="$refs.select.open = false">
														Nenhum registro encontrado
													</span>
												</v-select>
											</div>
											<div class="col">
												<div class="ml-2 font-weight-bold">Grupo de Trabalho</div>
												<v-select class="mb-2" placeholder="Selecione o Grupo" :tabindex="19"
													label="nomeComCoord" multiple :reduce="(c) => c.idgt"
													v-model="filtro.grupoTrabalho" :options="listaGT">
													<span slot="no-options" @click="$refs.select.open = false">
														Nenhum registro encontrado
													</span>
												</v-select>
											</div>
										</div>
									</div>
									<!-- div Atividade -->
									<div class="col-6 py-1 filtro-contexto-ativo-corpo">
										<div class="form-check">
											<div class="row">
												<div class="col-4">
													<input class="form-check-input" type="checkbox" value="true"
														v-model="filtro.atividadesituacaoNI" id="sitAtividadeCheck1" tabindex="20">
													<label class="form-check-label" for="sitAtividadeCheck1">
														Não Iniciada
													</label>
												</div>
												<div class="col-4">
													<input class="form-check-input" type="checkbox" value="true"
														v-model="filtro.atividadesituacaoEA" id="sitAtividadeCheck2" tabindex="21">
													<label class="form-check-label" for="sitAtividadeCheck2">
														Em Andamento
													</label>
												</div>
												<div class="col-4">
													<input class="form-check-input" type="checkbox" value="true"
														v-model="filtro.atividadedestaque" id="atividadedestaque" tabindex="22">
													<label class="form-check-label" for="atividadedestaque">
														Destaque
													</label>
												</div>
											</div>
											<div class="row">
												<div class="col-4">
													<input class="form-check-input" type="checkbox" value="true"
														v-model="filtro.atividadesituacaoCA" id="sitAtividadeCheck6" tabindex="23">
													<label class="form-check-label" for="sitAtividadeCheck6">
														Cancelada
													</label>
												</div>
												<div class="col-4">
													<input class="form-check-input" type="checkbox" value="true"
														v-model="filtro.atividadesituacaoCO" id="sitAtividadeCheck3" tabindex="24">
													<label class="form-check-label" for="sitAtividadeCheck3">
														Concluída
													</label>
												</div>
											</div>
											<div class="row">
												<div class="col-4">
													<input class="form-check-input" type="checkbox" value="true"
														v-model="filtro.atividadesituacaoAT" id="sitAtividadeCheck4" tabindex="25">
													<label class="form-check-label" for="sitAtividadeCheck4">
														Atrasada
													</label>
												</div>
												<div class="col-4">
													<input class="form-check-input" type="checkbox" value="true"
														v-model="filtro.atividadeReagendada" id="atividadeRA" tabindex="26">
													<label class="form-check-label" for="atividadeRA">
														Reagendada
													</label>
												</div>
											</div>
										</div>
										<div class="mt-2 row font-weight-bold">
											<div class="col">
												<div class="ml-2">Data Inicial</div>
												<flat-picker tabindex="27" id="atividadeDataInicio" autocomplete="off"
													v-mask="'##/##/####'"
													class="font-13 form-control datepicker" placeholder="Data Inicial"
													v-model="filtro.atividadeDataInicio" :config="configData"
													@blur.native="validarCampoData('atividadeDataInicio', $event)"
													@on-ready="habilitarDigitacaoData" />
											</div>
											<div class="col">
												<div class="ml-2">Data Final</div>
												<flat-picker tabindex="28" id="atividadeDataFim" autocomplete="off"
													v-mask="'##/##/####'"
													class="font-13 form-control datepicker" placeholder="Data Final"
													v-model="filtro.atividadeDataFim" :config="configData"
													@blur.native="validarCampoData('atividadeDataFim', $event)"
													@on-ready="habilitarDigitacaoData" />
											</div>
											<div class="col">
												<div class="ml-2">Data de Conclusão</div>
												<flat-picker tabindex="29" id="atividadeDataConclusao" autocomplete="off"
													v-mask="'##/##/####'"
													class="font-13 form-control datepicker"
													placeholder="Data de Conclusão"
													v-model="filtro.atividadeDataConclusao" :config="configData"
													@blur.native="validarCampoData('atividadeDataConclusao', $event)"
													@on-ready="habilitarDigitacaoData" />
											</div>
										</div>
										<div class="mt-2 row">
											<div class="col">
												<div class="ml-2 font-weight-bold">Atividade criada por</div>
												<v-select class="mb-2" placeholder="Selecione Usuário" label="nome" :tabindex="30"
													multiple :reduce="(u) => u.idusuario"
													v-model="filtro.atividadecriador" :options="listaUsuarios">
													<span slot="no-options" @click="$refs.select.open = false">
														Nenhum registro encontrado
													</span>
												</v-select>
											</div>
											<div class="col">
												<div class="ml-2 font-weight-bold">Responsável</div>
												<v-select class="mb-2" placeholder="Selecione Responsável" label="nome" :tabindex="31"
													multiple :reduce="(u) => u.idusuario"
													v-model="filtro.atividaderesponsavel" :options="listaUsuarios">
													<span slot="no-options" @click="$refs.select.open = false">
														Nenhum registro encontrado
													</span>
												</v-select>
											</div>
										</div>
										<div class="mt-2 row">
											<div class="col">
												<div class="ml-2 font-weight-bold">Investimento</div>
												<v-select class="mb-2" placeholder="Selecione o Investimento" :tabindex="32"
													label="descricao" :reduce="(c) => c.codigo"
													v-model="filtro.investimento" :options="listaInvestimento">
													<span slot="no-options" @click="$refs.select.open = false">
														Nenhum registro encontrado
													</span>
												</v-select>
											</div>
											<div class="col">
												<div class="ml-2 font-weight-bold">Tipo de Atividade</div>
												<v-select class="mb-2" placeholder="Selecione o Tipo de Atividade" :tabindex="33"
													label="nome" multiple :reduce="(c) => c.idsubtipoatividade"
													v-model="filtro.tipoAtividade" :options="listaTipoAtividade">
													<span slot="no-options" @click="$refs.select.open = false">
														Nenhum registro encontrado
													</span>
												</v-select>
											</div>
											<div class="col">
												<div class="ml-2 font-weight-bold">Grupo de Trabalho</div>
												<v-select class="mb-2" placeholder="Selecione o Grupo" :tabindex="34"
													label="nomeComCoord" multiple :reduce="(c) => c.idgt"
													v-model="filtro.grupoTrabalhoAtividade" :options="listaGT">
													<span slot="no-options" @click="$refs.select.open = false">
														Nenhum registro encontrado
													</span>
												</v-select>
											</div>
										</div>
										<div class="mt-2 row">
											<div class="col mt--2">
												<div class="input-group">
													<div class="input-group-prepend mr-n1" style="height: 30px;">
														<span class="input-group-text pt-2 pb-2"
															style="font-size: 13px !important;">R$</span>
													</div>
													<vue-numeric style="font-size: 13px; height: 30px;" tabindex="35"
														placeholder="Valor de Investimento" class="form-control"
														v-model="filtro.valorInvestimento" separator="."
														v-bind:precision="2" v-bind:minus="false">
													</vue-numeric>
												</div>
											</div>
	
											<div class="col-8 mt--2">
												<input id="inputTitulo" maxlength="200" tabindex="36" type="text" style="font-size: 13px; height: 30px;"
													class="form-control mb-2" v-model="filtro.nome"
													placeholder="Pesquisar atividade..." />
											</div>
										</div>
										<br>
										<div class="text-right mr-2 mt--3">
											<a class="btn btn-light" tabindex="37" @click.prevent="limparFiltro">
												<i class="fas fa-eraser mr-2"></i>
												Limpar Filtro
											</a>
											<a class="btn btn-info" tabindex="38" @click.prevent="filtrarAtividade">
												<i class="fas fa-filter mr-2"></i>
												Aplicar
											</a>
										</div>
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="container-fluid mt-2">
			<div class="container-fluid mt-2">
				<div class="card">
					<div class="card-body">
						<div class="row ml-0 mr-0 page-header-title">
							<div class="col-lg-3 col-sm-3 pr-0 pl-0 d-none d-sm-block d-lg-block d-xl-block">
								<h2 class="text-header txt-bloqueio">Atividades {{ (sortedAtividades.length > 0) ? "("+
									sortedAtividades.length +")" : "" }}</h2>
							</div>
							<div
								class="col-lg-6 col-sm-3 pr-0 pl-0 d-none d-sm-block d-lg-block d-xl-block d-flex justify-content-center">
								<b-pagination v-if="apresentaPaginacao == 'S'" v-model="currentPage"
									:total-rows="totalRegistros" :per-page="perPage" first-number
									@change="paginacaoAtividade"></b-pagination>
							</div>
							<div class="col-lg-3 col-sm-3 nput-search pl-0 nput-group d-flex pr-0">
								<!-- input class="input-pesquisa-imprimir inputiPad search-menu"
									placeholder="Pesquisar atividade..." v-model="filtroAtividade"
									@keyup="pesquisarAtividade" / -->
							</div>
						</div>
						<table class="table table-hover">
							<thead style="background-image: linear-gradient(to left, white, #f2f2f2)">
								<tr class="clickable">
									<th class="text-center" style="width: 50% !important" @click="sort('titulo')">
										Atividade <i class="text-muted fas fa-sort mr-2"></i></th>
									<th class="text-center" @click="sort('dataInicioOrdem')">Data início <i
											class="text-muted fas fa-sort mr-2"></i></th>
									<th class="text-center" @click="sort('dataFimOrdem')">Data fim <i
											class="text-muted fas fa-sort mr-2"></i></th>
									<th class="text-center" @click="sort('investimento')">Investimento <i
											class="text-muted fas fa-sort mr-2"></i></th>
									<!--<th class="text-center"  @click="sort('nomeResponsavel')">Responsável <i class="text-muted fas fa-sort mr-2"></i></th>-->
									<th class="text-center" @click="sort('situacaoDescricao')">Situação <i
											class="text-muted fas fa-sort mr-2"></i></th>
									<th style="width: 5% !important"></th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="atividade in sortedAtividades" :key="atividade.idatividade">
									<td style="width: 50% !important">
										<strong class="clickable" @click="abrirModalAtividade(atividade)">
											<i v-show="!atividade.destaque" class="text-muted far fa-star mr-1"></i>
											<i v-show="atividade.destaque" class="text-warning fas fa-star mr-1"></i>
											<span class="text-wrap">
												{{ atividade.nomeCodigo }}
											</span>
										</strong>
									</td>
									<td :class="(atividade.reagendada) ? 'font-reagenda' : ''">
										{{atividade.dataInicio}}
									</td>
									<td :class="(atividade.reagendada) ? 'font-reagenda' : ''">
										{{atividade.dataFim}}
									</td>
									<td style="text-align: right;">
										<el-tooltip content="Investimento" placement="top">
											<span>{{atividade.investimentoFmt}}</span>
										</el-tooltip>
										<el-tooltip content="Investimento Não Empenhado" placement="top"
												v-if="atividade.investimentoNaoEmpenho != null && atividade.investimentoNaoEmpenho > 0">
											<span>&nbsp; ({{atividade.investimentoNaoEmpenhoFmt}})</span>
										</el-tooltip>
									</td>
									<!--<td class="text-center" >
										<img : src="atividade.responsavel.avatar" : title="atividade.responsavel.apelido" width="30" class="rounded-circle mt-n1">
									</td>-->
									<td class="text-capitalize text-center">
										{{ atividade.situacaoDescricao }}
										<span :class="'font-' + atividade.situacao"
											v-if="atividade.situacao == 'CONCLUIDA' || atividade.situacao == 'CANCELADA'"><br />
											(em {{ atividade.dataConclusao }})
										</span>
										<span class="font-atrasada" v-if="atividade.situacao == 'ATRASADA'"><br />
											({{atividade.atrasada }})
										</span>
										<el-tooltip :content="atividade.progresso + '%'" placement="top"
											v-if="atividade.situacao == 'EMANDAMENTO'">
											<div class="progress mt-1">
												<div class="progress-bar" role="progressbar"
													:style="'font-size: 11px; width: ' + atividade.progresso + '%;'"
													:class="'progresso-' + atividade.situacao">
												</div>
											</div>
										</el-tooltip>
									</td>
									<td style="width: 5% !important">
										<el-tooltip v-if="exibirOpcaoAlterar(atividade)" content="Alterar"
											placement="top">
											<i @click="alterarAtividadeLista(atividade)"
												class="fas fa-edit ml-3 icones iconeAlterar"></i>
										</el-tooltip>
									</td>
								</tr>
							</tbody>
						</table>
						<div class="row">
							<div class="col-lg-12 d-flex justify-content-center">
								<div class="col-sm-6 d-flex justify-content-center">
									<b-pagination v-if="apresentaPaginacao == 'S'" v-model="currentPage"
										:total-rows="totalRegistros" :per-page="perPage" first-number
										@change="paginacaoAtividade">
									</b-pagination>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>
		<modal id="modalAtv" :show.sync="modals.modalAtividade" size="xl">
			<div class="text-right iconeFecharModal">
				<span @click="closeModalAtividade()" class="pull-right clickable close-icon" data-effect="fadeOut"><i
						class="fa fa-times"></i></span>
			</div>
			<Atividade v-if="modals.modalAtividade" @atualizar-lista="filtrarAtividade"
				@fechar-atividade="closeModalAtividade" @abrir-projeto="abrirModalProjeto"
				:atividadeSelecionada=atividadeModal />
		</modal>

		<modal id="modalProj" :show.sync="modals.modalProjeto" size="xl">
			<div class="text-right iconeFecharModal">
				<span @click="closeModalProjeto()" class="pull-right clickable close-icon" data-effect="fadeOut"><i
						class="fa fa-times"></i></span>
			</div>
			<Projeto v-if="modals.modalProjeto" @fechar-projeto="closeModalProjeto"
				@abrir-atividade="abrirModalAtividade" :projetoSelecionado=projetoModal />
		</modal>

		<modal id="modalEdicaoAtividade" :show.sync="modals.modalEdicaoAtividade" size="xl">
			<div class="text-right iconeFecharModal">
				<span @click="closeModalEdicaoAtividade()" class="pull-right clickable close-icon" data-effect="fadeOut"><i
						class="fa fa-times"></i></span>
			</div>
			<AtividadeFormulario v-if="modals.modalEdicaoAtividade" 
				@atualizar-lista="filtrarAtividade"
				@fechar-cadastro="closeModalEdicaoAtividade"
				:atividadeSelecao=atividadeEdicao />
		</modal>
	</div>
</template>

<script>
const customLabels = {
	first: "<<",
	last: ">>",
	previous: "<",
	next: ">",
};

const defaultStyles = {
	ul: {
		margin: 0,
		padding: 0,
		display: "inline-block",
	},
	li: {
		listStyle: "none",
		display: "inline",
		textAlign: "center",
	},
	a: {
		cursor: "pointer",
		padding: "7px 7px",
		display: "block",
		float: "left",
	},
};

import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "vue-select/dist/vue-select.css";
import Atividade from "@/components/Atividade.vue";
import Projeto from "@/components/Projeto.vue";
import AtividadeFormulario from "@/components/AtividadeFormulario.vue";


export default {
	components: {
		Atividade,
		Projeto,
		AtividadeFormulario,
		flatPicker
	},
	created() {
		this.carregarTela();
	},
	data() {
		return {
			pageOfItems: [],
			progress: false,
			listaAtividade: [],
			listaAtividadeFiltro: [],
			listaClassificacao: [],
			listaRelevancia: [],
			listaGT: [],
			listaInvestimento: [],
			listaTipoAtividade: [],
			listaProjetos: [],
			listaUsuarios: [],
			filtroAtividade: "",
			apresentaPaginacao: "N",
			configData: {
				allowInput: true,
				clickOpens: true,
				disableMobile: true,
				dateFormat: "d/m/Y",
			},
			filtro: {
				atividadesituacaoNI : true,
				atividadesituacaoEA : true,
				atividadesituacaoAT : true,
				ordem: 1,
			},
			customLabels,
			defaultStyles,
			atividade: {},
			modals: {
				modalProjeto: false,
				modalAtividade: false,
				modalEdicaoAtividade: false,
			},
			projetoModal: null,
			atividadeModal: null,
			atividadeEdicao: null,
			currentSort:'titulo',
  			currentSortDir:'asc',
			paginaAtual:1,
			totalRegistros:0,

			rows: 0,
			perPage: 50,
			currentPage: 1

		};
	},
	
	computed:{
		sortedAtividades:function() {
			return this.listaAtividade.sort((a,b) => {
				let modifier = 1;
				if(this.currentSortDir === 'desc') modifier = -1;
				if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
				if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
				return 0;
			});
		}
	},
	methods: {
		dataValida(valor) {
			if (typeof valor !== "string" || !/^\d{2}\/\d{2}\/\d{4}$/.test(valor)) {
				return false;
			}
			const partes = valor.split("/").map(Number);
			const dia = partes[0];
			const mes = partes[1];
			const ano = partes[2];
			if (ano < 1900) {
				return false;
			}
			const data = new Date(ano, mes - 1, dia);
			return data.getFullYear() === ano
				&& data.getMonth() === mes - 1
				&& data.getDate() === dia;
		},
		validarCampoData(campo, evento) {
			const valor = evento && evento.target ? evento.target.value : this.filtro[campo];
			if (!valor) {
				this.$set(this.filtro, campo, "");
				return true;
			}
			if (this.dataValida(valor)) {
				this.$set(this.filtro, campo, valor);
				return true;
			}
			this.$toastr.warning("Data inválida. Informe uma data válida no formato dd/mm/aaaa");
			this.$set(this.filtro, campo, "");
			if (evento && evento.target) {
				evento.target.value = "";
			}
			return false;
		},
		converterDataFiltro(valor) {
			const partes = valor.split("/").map(Number);
			return new Date(partes[2], partes[1] - 1, partes[0]);
		},
		validarPeriodoFiltro(campoInicial, campoFinal, entidade) {
			const dataInicial = this.filtro[campoInicial];
			const dataFinal = this.filtro[campoFinal];
			if (!dataInicial || !dataFinal) {
				return true;
			}
			if (this.converterDataFiltro(dataFinal) <= this.converterDataFiltro(dataInicial)) {
				this.$toastr.warning(`A data final ${entidade} deve ser maior que a data inicial.`);
				return false;
			}
			return true;
		},
		validarPeriodosFiltro() {
			return this.validarPeriodoFiltro("projetoDataInicio", "projetoDataFim", "do projeto")
				&& this.validarPeriodoFiltro("atividadeDataInicio", "atividadeDataFim", "da atividade");
		},
		habilitarDigitacaoData(...parametros) {
			const instancia = parametros[2];
			if (instancia && instancia._input) {
				instancia._input.removeAttribute("readonly");
			}
		},
		sort:function(s) {
			if(s === this.currentSort) {
			this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
			}
			this.currentSort = s;
		},
		carregarTela() {
			this.progress = true;

			let filtro = { 
				idPerfil: localStorage.getItem("trocaPerfil"), 
				paginaAtual: 0,
				atividadesituacaoNI : true,
				atividadesituacaoEA : true,
				atividadesituacaoAT : true,
				ordem: 1,
			};

			let paginaAtual = 0; // Exemplo: primeira página
			let tamanhoPagina = 50; // Exemplo: 10 registros por página
			let ordenacao = "dataFim,desc"; // Ordenação por dataFim decrescente
			// Montar a URL com parâmetros de paginação e ordenação
			let params = new URLSearchParams();
			params.append("page", paginaAtual);
			params.append("size", tamanhoPagina);
			params.append("sort", ordenacao);
			// Fazer a chamada para a API com os parâmetros de paginação
			this.$clubApi.post(`/atividade/lista-paginada?${params.toString()}`, filtro)
				.then((response) => {

					this.listaAtividade = response.data.object.atividades;
					this.listaAtividadeFiltro = response.data.object.atividades;
					this.totalRegistros = response.data.object.totalRegistros;
					this.apresentaPaginacao = response.data.object.apresentaPaginacao;


					this.$clubApi.get("/user/responsaveis").then((response) => {
						this.listaUsuarios = response.data.object;
					});
					this.$clubApi.get("/estrutura/gt/ativoperfil/" + filtro.idPerfil).then((response) => {
						this.listaGT = response.data.object;
					});
					this.$clubApi.get("/atividade/tipos").then((response) => {
						this.listaTipoAtividade = response.data.object;
					});
				})
				.catch((error) => {
					this.$toastr.error(error.response.data.msg);
				})
				.finally(() => {
					this.progress = false;
				});

			this.$clubApi.post("/projeto/lista", filtro).then((response) => {
				this.listaProjetos = response.data.object;
			})
			this.$clubApi.get("/enum/classificacao").then((response) => {
				this.listaClassificacao = response.data.object;
			});
			this.$clubApi.get("/enum/relevancia").then((response) => {
				this.listaRelevancia = response.data.object;
			});
			this.listaInvestimento = [{ codigo: "MAIOR", descricao: "Maior igual a" }, { codigo: "MENOR", descricao: "Menor igual a" }, { codigo: "IGUAL", descricao: "Igual a" }]
		
			this.sort('dataFimOrdem')
		},
		
		filtrarAtividade() {
		if (!this.validarPeriodosFiltro()) {
			return;
		}
		this.progress = true;
		this.filtro.idPerfil = localStorage.getItem("trocaPerfil")
		this.filtro.paginaAtual = 0	
		
		let paginaAtual = 0; // Exemplo: primeira página
        this.currentPage = 1;
			let tamanhoPagina = 50; // Exemplo: 10 registros por página
			let ordenacao = "dataFim,desc"; // Ordenação por dataFim decrescente

			// Montar a URL com parâmetros de paginação e ordenação
			let params = new URLSearchParams();
			params.append("page", paginaAtual);
			params.append("size", tamanhoPagina);
			params.append("sort", ordenacao);

		
			this.$clubApi.post(`/atividade/lista-paginada?${params.toString()}`, this.filtro).then((response) => {
			this.listaAtividade = response.data.object.atividades;
			this.listaAtividadeFiltro = response.data.object.atividades;
			this.totalRegistros = response.data.object.totalRegistros;
			this.apresentaPaginacao = response.data.object.apresentaPaginacao;
		})
			.catch((error) => {
				this.$toastr.error(error.response.data.msg);
			})
			.finally(() => {
				this.progress = false;
			});
		},


		limparFiltro() {
			this.filtro = {
				ordem: 1
			}
			this.filtrarAtividade();
		},
		abrirModalProjeto(projeto) {
			this.projetoModal = projeto;
			this.modals.modalProjeto = true;
		},
		abrirModalAtividade(atividade) {
			this.atividadeModal = atividade;
			this.modals.modalAtividade = true;
		},
		onChangePage(pageOfItems) {
			this.pageOfItems = pageOfItems;
		},
		
		pesquisarAtividade() {
			if (this.filtroAtividade === "") {
				this.listaAtividade = this.listaAtividadeFiltro;
			} else {
				this.listaAtividade = this.listaAtividadeFiltro.filter((item) => {
					return (
						item.nomeCodigo.toUpperCase().indexOf(this.filtroAtividade.toUpperCase()) >= 0
					);
				});
			}
		},

		closeModalAtividade() {
			this.modals.modalAtividade = false;
		},
		closeModalProjeto() {
			this.modals.modalProjeto = false;
		},
		closeModalEdicaoAtividade() {
			this.modals.modalEdicaoAtividade = false;
			this.atividadeEdicao = null;
		},
        alterarAtividadeLista(atividade){
            this.progress = true;
            this.$clubApi.get("/atividade/" + atividade.idatividade).then((response) => {
                this.atividadeEdicao = response.data.object;
                this.modals.modalEdicaoAtividade = true;
            }).catch((error) => {
                this.$toastr.error(error.response.data.msg);
            }).finally(() => {
                this.progress = false;
            });
        },
		incluirAtividade(){
            location.href = '/atividade-cadastro';
        },
        exibirOpcaoAlterar(atividade) {
			let perfilAdmin = (localStorage.getItem("pnome") === "ADMIN");
            return perfilAdmin || (atividade.situacao !='CANCELADA' && atividade.situacao != 'CONCLUIDA');
        },
		alterarAtividade(atividade) {
			const options = {
				title: "Confirmação",
				okLabel: "Confirmar",
				cancelLabel: "Não",
			};
			this.$dialogs.confirm('Deseja ir para o cadastro de alteração dessa atividade?', options)
				.then((res) => {
				if (res.ok) {
					location.href = '/atividade-cadastro/'+ atividade.idatividade;
				}
			});
		},
		cancelarAtividade(atividade) {
			const options = {
				title: "Confirmação",
				okLabel: "Confirmar",
				cancelLabel: "Não",
			};
			this.$dialogs.confirm('Deseja realmente cancelar esse atividade em definitivo?', options)
				.then((res) => {
					if (res.ok) {
						this.progress = true;
						let atividadeRequest = {
							idatividade: atividade.idatividade
						}
						this.$clubApi.post("/atividade/cancelar/", atividadeRequest).then(() => {
							this.carregarAtividades();
							this.$toastr.success("Atividade cancelada com sucesso!");
						})
						.catch((error) => {
							this.$toastr.warning(error.response.data.msg);
						})
						.finally(() => {
							this.progress = false;
						});
					}
				});
		},
		carregarAtividades() {
			this.progress = true;
			let filtro = {idPerfil:localStorage.getItem("trocaPerfil")};
			this.$clubApi.post("/atividade/lista", filtro).then((response) => {
				this.listaAtividade = response.data.object;
				this.listaAtividadeFiltro = response.data.object;
			})
			.catch((error) => {
				this.$toastr.error(error.response.data.msg);
			})
			.finally(() => {
				this.progress = false;
			});
		},
		onChangePage(pageOfItems) {
      this.pageOfItems = pageOfItems;
    },

	paginacaoAtividade(pgAtual) {
	  this.consultaPaginada(pgAtual)
    },
	consultaPaginada(pgAtual) {
			let params = new URLSearchParams();
			params.append("page", pgAtual - 1);
			params.append("size", 50);
			this.progress = true;
			this.filtro.idPerfil = localStorage.getItem("trocaPerfil")
			this.filtro.paginaAtual = pgAtual - 1;
			this.$clubApi.post(`/atividade/lista-paginada?${params.toString()}`, this.filtro).then((response) => {
				this.listaAtividade = response.data.object.atividades;
				this.listaAtividadeFiltro = response.data.object.atividades;
				this.totalRegistros = response.data.object.totalRegistros;
				this.apresentaPaginacao = response.data.object.apresentaPaginacao;
			})
				.catch((error) => {
					this.$toastr.error(error.response.data.msg);
				})
				.finally(() => {
					this.progress = false;
				});

		},
	}
}
</script>
<style scoped>
.container-fluid { padding-left: 10px !important; padding-right: 10px !important; }
.clickable {
	cursor: pointer;
}
.font-13 {
    font-size: 13px;
}

.filtro-contexto-ativo {
	background-color: #f2fbfc !important;
	border: 1px solid #32cbe2 !important;
}

.filtro-contexto-ativo-corpo {
	background-color: #f2fbfc !important;
	border: 1px solid #32cbe2 !important;
}

.filtro-contexto-inativo {
	background-color: #fff !important;
	border: 1px solid #b1b1b1 !important;
}

.filtro-contexto-inativo-corpo {
	background-color: #fff !important;
	border: 1px solid #b1b1b1 !important;
}

.font-reagenda {
	color: #b821bd !important;
	font-weight: 600;
}
.font-atrasada {
	color: red !important;
}
.font-CONCLUIDA {
	color: green !important;
}
.font-CANCELADA {
	color: red !important;
}
.centered-pagination {
    display: flex;
    justify-content: center;
}
</style>
